import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { T } from '../../../../../../../Translations';

interface Props {
  hours: Maybe<number>;
}

function ProgramHours({ hours }: Props) {
  return hours
    .map((count) => (
      <span className="text-foreground text-xs">
        <T kind="{{count}} Hour" count={count} />
      </span>
    ))
    .getOrElse(emptyFragment);
}

export default observer(ProgramHours);
